import React from 'react'

import TitleIcons from 'components/TitleIcons'

export const BrandIcons = ({ paymentMethodSlug, paymentMethodSrc, processorSlug, processorSrc, size }) => (
	<TitleIcons
		icons={[
			(paymentMethodSlug || paymentMethodSrc) && { src: paymentMethodSrc, name: paymentMethodSlug },
			(processorSlug || processorSrc) && { src: processorSrc, name: processorSlug },
		].filter(Boolean)}
		size={size}
	/>
)
